import { Routes, Route } from 'react-router-dom'
import { Layout } from './components/Layout'
import { Dashboard } from './pages/Dashboard'
import { Customers } from './pages/Customers'
import { CustomerDetail } from './pages/CustomerDetail'
import { Deployments } from './pages/Deployments'
import { Configuration } from './pages/Configuration'
// import { Monitoring } from './pages/Monitoring' // Moved to legacy
// import { Documentation } from './pages/Documentation' // Moved to legacy

function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/customers" element={<Customers />} />
        <Route path="/customers/:id" element={<CustomerDetail />} />
        <Route path="/deployments" element={<Deployments />} />
        <Route path="/configuration" element={<Configuration />} />
        {/* Advanced features disabled in MVP - available in legacy/ */}
        {/* <Route path="/monitoring" element={<Monitoring />} /> */}
        {/* <Route path="/docs" element={<Documentation />} /> */}
        {/* <Route path="/docs/:section" element={<Documentation />} /> */}
      </Routes>
    </Layout>
  )
}

export default App